import axios from "axios";

export const LOGIN_URL = "https://university.auanet.org/mobileapps/admin/login/main.cfc?method=remoteLogin";
export const MAIN_URL = "https://university.auanet.org/mobileapps/admin/sasp/main.cfc";
export const DEV_URL = "https://university.auanet.org/mobileapps/dev/sasp/main.cfc";

export const LOGIN_AXIOS = () => {
    return axios.create({
        baseURL: LOGIN_URL,
        timeout: 1000 * 60 * 5
    });
};

export const BASE_AXIOS = () => {
    return axios.create({
        baseURL: MAIN_URL,
        timeout: 1000 * 60 * 5
    });
};

export const DEV_AXIOS = () => {
    return axios.create({
        baseURL: DEV_URL,
        timeout: 1000 * 60 * 5
    });
};